module.exports = __webpack_public_path__ + "static/img/m_sidebar_faq@3x.a6cea10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_sidebar_faq@3x.png
// module id = sQ3c
// module chunks = 1